module.exports = __webpack_public_path__ + "static/media/icon_custom_appbar_filter_white.03a4fc68.svg";